import { privateRequest, type ApiResponse } from "../axios";

export interface TemplateModule {
  Id: number;
  Name: string;
}

export interface TemplateType {
  Id: number;
  Name: string;
  ModuleName: string;
}

export interface TemplateField {
  Id: number;
  ModuleId: number;
  TypeId: number;
  ModuleName: string;
  TypeName: string;
  PlaceholderKey: string;
  DisplayName: string;
  EntityName: string;
  EntityField: string | null;
  IsCollection: boolean;
  CollectionKey: string | null;
  ParentCollectionKey: string | null;
  ChildFields: TemplateField[];
}

export interface TemplateItem {
  Id: number;
  CompanyId: number;
  Name: string;
  ModuleName: string;
  TypeName: string;
  Subject: string;
  Body: string;
  CreatedBy: string;
  ModifiedBy: string;
}

export interface TemplateListResponse {
  TotalRecords: number;
  Items: TemplateItem[];
}

const ENDPOINTS = {
  MODULES: "/api/Modules",
  TYPES: "/api//Type",
  FIELDS: "/api/TemplateFields",
  TEMPLATES: "/api/Template",
};

const getModules = async (): Promise<ApiResponse<TemplateModule[]>> => {
  const response = await privateRequest.get<ApiResponse<TemplateModule[]>>(ENDPOINTS.MODULES);
  return response.data;
};

const getTemplateTypes = async (moduleId: number): Promise<ApiResponse<TemplateType[]>> => {
  const response = await privateRequest.get<ApiResponse<TemplateType[]>>(`${ENDPOINTS.TYPES}/${moduleId}`);
  return response.data;
};

const getTemplateFields = async (typeId: number, moduleId: number): Promise<ApiResponse<TemplateField[]>> => {
  const response = await privateRequest.get<ApiResponse<TemplateField[]>>(`${ENDPOINTS.FIELDS}?typeId=${typeId}&moduleId=${moduleId}`);
  return response.data;
};

const getTemplates = async (payload: any): Promise<ApiResponse<TemplateListResponse>> => {
  const response = await privateRequest.get<ApiResponse<TemplateListResponse>>(ENDPOINTS.TEMPLATES, { params: payload });
  return response.data;
};

const saveTemplate = async (payload : any) => {
  const response = await privateRequest.post(ENDPOINTS.TEMPLATES, payload);
  return response.data;
};

const getTemplateById = async (id: number): Promise<ApiResponse<TemplateItem>> => {
  const response = await privateRequest.get<ApiResponse<TemplateItem>>(`${ENDPOINTS.TEMPLATES}/${id}`);
  return response.data;
}

const CustomTemplateService = {
  getModules,
  getTemplateTypes,
  getTemplateFields,
  getTemplates,
  saveTemplate,
  getTemplateById
};

export default CustomTemplateService;
